var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.browserIsNotSupported)?_c('browse-happy-alert'):_vm._e(),_vm._v(" "),_c('div',{staticClass:"content container px-0 px-md-4"},[(_vm.pageTemplate && _vm.content.nestedContent)?_c(_vm.pageTemplate,{tag:"component",attrs:{"content":_vm.content}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }